<template>
  <div class="h-100">
    <v-window v-model="alert" class="h-100">
      <v-window-item v-for="alert in alerts" :key="alert" class="h-100 px-2">
        <div
          class="d-flex flex-grow-1 justify-center align-center text-truncate"
        >
          <v-icon class="mr-2" style="font-size: 4vh">mdi-alert</v-icon>
          <span style="font-size: 3vh">{{ alert }}</span>
        </div>
      </v-window-item>
    </v-window>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, ref } from "vue";

const props = defineProps<{ alerts: string[] }>();

const alert = ref(0);
const length = computed(() => props.alerts.length);

onBeforeMount(() => {
  const time = 10000;

  setInterval(() => {
    if (length.value > 0) {
      next();
    }
  }, time);
});

function next() {
  alert.value = alert.value + 1 > length.value - 1 ? 0 : alert.value + 1;
}

function prev() {
  alert.value = alert.value - 1 <= 0 ? length.value - 1 : alert.value - 1;
}
</script>
